import { useEffect } from 'react'
import { Typography, Card, List, Divider } from 'antd'
import { MailOutlined, CustomerServiceOutlined, CrownOutlined } from '@ant-design/icons'
import { Helmet } from 'react-helmet'
import * as API_TELEGRAM from '../../../../shared/http/telegram-notification'
import Constants from '../../../../const/Constants'

const { Title, Paragraph, Text } = Typography

const features = [
    'Неограниченное количество слов в словаре',
    'Неограниченное количество сообществ',
    'Полный доступ ко всем спискам слов',
    'AI-ассистент для обучения',
    'Генерация карточек и списков с ИИ',
    'Аудио-диалоги с ИИ',
    'Добавление слов через Telegram',
    'Приоритетная поддержка',
]

const PremiumHelp = () => {
    useEffect(() => {
        API_TELEGRAM.notifyTelegramBot('Перешел на страницу помощи при покупке')
    }, [])

    return (
        <div style={{ maxWidth: 800, margin: '0 auto', padding: '3rem 1rem' }}>
            <Helmet title='Премиум подписка' />

            <div style={{ textAlign: 'center', marginBottom: 32 }}>
                <CrownOutlined style={{ fontSize: 48, color: 'var(--color-premium)' }} />
                <Title level={2}>VoxLingua Премиум</Title>
                <Text type="secondary">
                    Откройте максимум возможностей для изучения языков
                </Text>
            </div>

            <Card bordered style={{ marginBottom: 32 }}>
                <Title level={4}>Что входит в Премиум</Title>
                <List
                    size="large"
                    dataSource={features}
                    renderItem={(item) => (
                        <List.Item>
                            <Text>{item}</Text>
                        </List.Item>
                    )}
                />
            </Card>

            <Card bordered style={{ marginBottom: 32 }}>
                <Title level={4}>Как оформить подписку?</Title>
                <Paragraph>
                    Для оформления подписки перейдите на наш сайт <Text strong>{Constants.DOMAIN}</Text> и
                    авторизуйтесь в личном кабинете.
                </Paragraph>
                <Paragraph>
                    Если у вас уже есть промокод, введите его в приложении: откройте профиль и нажмите
                    «Меню» → «Ввести промокод».
                </Paragraph>
            </Card>

            <Divider />

            <Card>
                <Title level={4}>Нужна помощь?</Title>
                <Paragraph>
                    Напишите нам — мы ответим как можно быстрее:
                </Paragraph>
                <List
                    size="small"
                    dataSource={[
                        {
                            icon: <MailOutlined />,
                            label: 'Почта: ',
                            value: 'geekenglish@yandex.ru',
                            href: 'mailto:geekenglish@yandex.ru',
                        },
                        {
                            icon: <CustomerServiceOutlined />,
                            label: 'Telegram: ',
                            value: '@netty_af',
                            href: 'https://t.me/netty_af',
                        },
                    ]}
                    renderItem={(item) => (
                        <List.Item>
                            {item.icon}{' '}
                            <Text>
                                {item.label}
                                <a href={item.href} target="_blank" rel="noreferrer">
                                    {item.value}
                                </a>
                            </Text>
                        </List.Item>
                    )}
                />
            </Card>
        </div>
    )
}

export default PremiumHelp